import { jsx } from "panel";
import { QueryBuilderEl } from "../query-builder";
import { RowLabelType } from "../query-entry-section/types";
export function template() {
  var _a;
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(QueryBuilderEl, {
    params: {
      contained: true,
      entries: this.cohort.groups,
      addEntryButtonLabel: `Group`,
      allowCohortFilter: true,
      entryRowLabelType: RowLabelType.None,
      entriesDraggable: true,
      includeCustomProperties: `all`,
      showAnyEvent: true,
      showSessions: true,
      mainEntryNonCollapsible: this.params.nonCollapsible,
      rowLimit: 26,
      disableAddEntry: this.cohort.groups.length === 1 && this.cohort.groups[0].filters.length === 0,
      headerTitle: this.params.headerTitle,
      headerTitleLowercase: true,
      hideDatePicker: true,
      hideEditControls: this.params.hideEditControls,
      hideFilter: true,
      hideGroupBy: true,
      behaviorMode: true,
      hideDataGroupsSelector: true,
      allDataGroups: true,
      dataGroupId: (_a = this.cohort.dataGroupId) != null ? _a : ``,
      dataGroupsEnabled: this.params.supportB2bCohorts,
      maxDataHistoryDays: this.params.maxDataHistoryDays,
      rowTypes: this.rowTypes,
      supportB2bCohorts: this.params.supportB2bCohorts,
      projectHasCohorts: this.params.projectHasCohorts,
      inlineCohortsOverride: { enable: false },
      trackName: `cohorts`,
      projectHasPeople: this.hasPeopleEnabled(),
      projectAsOfDate: this.getProjectAsOfDate(),
      projectId: this.params.projectId,
      workspaceId: this.params.workspaceId,
      userId: this.params.userId,
      footerItems: this.params.footerItems
    },
    on: { update: (ev) => this.handleQueryUpdate(ev) }
  }));
}
